// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/built-up-area-landing-restrictions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/built-up-area-landing-restrictions/built-up-area-landing-restrictions.js';

mount([g0]);
